// @flow
import * as React from 'react';
import {useEffect, useState} from 'react';
import Axios from "axios";
import {mainUrl} from "../../common/common";
import {Button, Col, Dropdown, Form, FormGroup, Modal, Row, Spinner, Table} from "react-bootstrap";
import {CardBody, CardHeader, CardTitle, Input} from "reactstrap";
import toast from "react-hot-toast";
import ImageSelect from "./utils/imageSelect";
import image from "../../assets/img/photo.png";

export default function SubCategory(headers) {
    const [showModal, setShowModal] = React.useState(false);
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    const [showAddImage, setShowAddImage] = React.useState(false);
    const [recordId, setRecordId] = React.useState(0);
    const [category, setCategory] = React.useState([]);
    const [list, setList] = React.useState([]);
    const [property, setProperty] = React.useState({});

    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        fetchCategory();
        fetchList();
    }, []);

    const fetchCategory = async () => {
        const {data} = await Axios.get(mainUrl + "getCategory", headers);
        const lists = data;
        setCategory(lists);
    };
    const fetchList = async () => {
        const {data} = await Axios.get(mainUrl + "getSubCategory", headers);
        const lists = data;
        setList(lists);
        setIsLoading(true);
    };
    const addSubCategory = async (e) => {
        e.preventDefault();
        await Axios.post(mainUrl + "addSubCategory", {
            id: e.target.id.value,
            image: e.target.image.value,
            category_id: e.target.category_id.value,
            description: e.target.description.value,
            name: e.target.name.value,


            name_fa: e.target.name_fa.value,
            description_fa: e.target.description_fa.value,

            name_pa: e.target.name_pa.value,
            description_pa: e.target.description_pa.value,

        }, headers).then(res => {
            if (e.target.id.value == 0) {
                notifySuccess(' Added Successfully.');
            } else {
                notifySuccess(' Updated Successfully.');
            }
            setList(res.data);
            setShowModal(false);
        }).catch(function (error) {
            notifyError(error.response.data.message);
            setShowModal(false);
        });
    };


    const notifyError = (message) => toast.error(message, {
        duration: 6000,
    });
    const notifySuccess = (message) => toast.success(message, {
        duration: 6000,
    });
    return (
        <>

            <div className="content">
                {isLoading === false ? (
                    <div className="text-center">
                        <Spinner animation="border" variant="info"/>
                    </div>
                ) : (
                    <div>
                        <AddItem/>
                        <TableData/>
                    </div>
                )}
            </div>
        </>
    );

    function DeleteItem() {

        const onDeleteRecord = async (e) => {
            e.preventDefault();
            await Axios.post(mainUrl + "deleteSubCategory", {
                id: recordId
            }, headers).then(res => {
                notifySuccess("Successfully deleted");
                const lists = res.data;
                setList(lists);
            }).catch((error) => {
                notifyError(error.response.data.message);

            });
            setRecordId(0);
            setShowDeleteModal(false);
        }

        return (
            <>
                <Modal show={showDeleteModal} backdrop="static" size="md" onHide={() => setShowDeleteModal(false)}>
                    <form onSubmit={(e) => onDeleteRecord(e)}>
                        <Modal.Header>
                            <div className="modal-profile  text-gray">
                                <h2>Confirmation</h2>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="pr-3  text-gray">
                                <Col md="12">
                                    Are you sure you want to delete?
                                </Col>
                            </Row>
                        </Modal.Body>
                        <div className="modal-footer">
                            <Button title="Close"
                                    className="btn-simple"
                                    type="button"
                                    variant="link"
                                    onClick={() => setShowDeleteModal(false)}>
                                Close
                            </Button>
                            <Button title="Yes , I am sure" className="btn-round" color="danger" type="submit">
                                Yes
                            </Button>
                        </div>
                    </form>
                </Modal>
            </>
        );
    }


    function AddItem() {
        const [showUploadImage, setShowUploadImage] = useState(false);
        const [localImageCategory, setLocalImageCategory] = useState("");

        useEffect(() => {
            setTimeout(() => setLocalImageCategory(sessionStorage.getItem("categoryImage")), 1000);
        }, []);

        return (
            <>
                {showUploadImage == true &&
                <ImageSelect setShowUploadImage={setShowUploadImage} setLocalImageCategory={setLocalImageCategory}/>}

                <Modal show={showModal} backdrop="static" size="xl" onHide={() => setShowModal(false)}>
                    <Form onSubmit={(e) => {
                        document.getElementById("submit").disabled = true;
                        addSubCategory(e)
                    }}>
                        <div className="hideInput">
                            <Input type="text" className="hidden" required name="id" id="id"
                                   defaultValue="0"/>
                            <Input type="text" name="image" id="image" value={localImageCategory}/>
                        </div>

                        <Modal.Header className="justify-content-center">
                            <div className="modal-profile">
                                New SubCategory
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="pr-3">
                                <Col md="6">
                                    <FormGroup>
                                        <label>Category</label>
                                        <select id="category_id" name="category_id" required
                                                className="form-control">
                                            <option value=""></option>
                                            {category.map((e) => (
                                                <option key={e.id}
                                                        value={e.id}>{e.name}</option>
                                            ))}
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>SubCategory name <span className="text text-danger">*</span></label>
                                        <Input required name="name" id="name"
                                               placeholder="SubCategory name" title="SubCategory name" type="text"/>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="pr-3" md="12">
                                    <FormGroup>
                                        <label>Description <span className="text text-danger">*</span></label>
                                        <br/>
                                        <textarea required row="10" className="form-control"
                                                  style={{maxHeight: "500px!important"}} name="description"
                                                  title="Description" id="description"
                                                  placeholder="Description" type="text">
                                        </textarea>
                                    </FormGroup>
                                    <p className="text-danger" style={{fontSize:"10pt"}}> 250 max character</p>
                                </Col>
                            </Row>

                            <hr/>
                            {/*farsi*/}
                            <Row className="pr-3">
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Name Farsi <span className="text text-danger">*</span></label>
                                        <Input required name="category_fa" title="Category Name" id="name_fa"
                                               placeholder="name" type="text"/>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="pr-3" md="12">
                                    <FormGroup>
                                        <label>Description Farsi <span className="text text-danger">*</span></label>
                                        <br/>
                                        <textarea required row="10" className="form-control"
                                                  style={{maxHeight: "500px!important"}} name="description_fa"
                                                  title="Description" id="description_fa"
                                                  placeholder="Description" type="text">
                                        </textarea>
                                    </FormGroup>
                                    <p className="text-danger" style={{fontSize:"10pt"}}> 250 max character</p>
                                </Col>
                            </Row>
                            <hr/>
                            {/*pashto*/}
                            <Row className="pr-3">
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Name Pashto <span className="text text-danger">*</span></label>
                                        <Input required name="category_pa" title="Category Name" id="name_pa"
                                               placeholder="name" type="text"/>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="pr-3" md="12">
                                    <FormGroup>
                                        <label>Description Pashto <span className="text text-danger">*</span></label>
                                        <br/>
                                        <textarea required row="10" className="form-control"
                                                  style={{maxHeight: "500px!important"}} name="description_pa"
                                                  title="Description" id="description_pa"
                                                  placeholder="Description" type="text">
                                        </textarea>
                                    </FormGroup>
                                    <p className="text-danger" style={{fontSize:"10pt"}}> 250 max character</p>
                                </Col>
                            </Row>


                            <Row>
                                <Col>
                                    <div className="text-center">
                                        <div
                                            style={{position: "relative", textAlign: "center", color: "white"}}
                                            alt="Image "
                                            title="Image">
                                            <img src={localImageCategory != "" ? localImageCategory : image}
                                                 style={{
                                                     borderRadius: "5%",
                                                     backgroundColor: "#8080805e!important",
                                                     cursor: "pointer"
                                                 }}
                                                 onClick={() => {
                                                     if (!showUploadImage) {
                                                         setShowUploadImage(true);
                                                     } else {
                                                         setShowUploadImage(false);
                                                     }
                                                 }} width="400" height="400"/>
                                            <div style={{
                                                position: "absolute",
                                                top: "85%",
                                                left: "50%",
                                                transform: "translate(-50%, 50%)",
                                                whiteSpace: "nowrap"
                                            }} className="text-primary">Select Image <br/> (400px) X (400px) <br/> Resize Image: <a href="https://www.resizepixel.com/" target="_blank">resizepixel.com</a>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                        </Modal.Body>
                        <div className="modal-footer">
                            <Button title="Close"
                                    className="btn-simple"
                                    type="button"
                                    variant="link"
                                    onClick={() => setShowModal(false)}>
                                Close
                            </Button>
                            <Button title="Insert & update  Record" className="btn-round" color="danger" id="submit" type="submit">
                                Add
                            </Button>
                        </div>
                    </Form>
                </Modal>
            </>
        );
    }

    function TableData() {
        let no = 1;
        return (
            <>
                <DeleteItem/>
                <Row>
                    <Col md="12">
                        <div className="card-user">
                            <CardHeader>
                                <CardTitle className="mr-4 ml-4">
                                    <div className="row">
                                        <div className="ml-right">
                                            <h2> Sub Category List </h2>
                                        </div>
                                        <div className="ml-end">
                                            <Button title="Add New Record" className="btn-info" variant="primary"
                                                    onClick={() => {
                                                        setRecordId(0);
                                                        setShowModal(true);
                                                        sessionStorage.setItem("categoryImage", "");
                                                    }}>
                                                <span className="nc-icon nc-simple-add"/>
                                            </Button>
                                        </div>
                                    </div>
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Table>
                                    <thead className="text-info">
                                    <tr>
                                        <th>No</th>
                                        <th>Category Nam</th>
                                        <th>SubCategory Name</th>
                                        <th>Description</th>
                                        <th className="text-right">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {list.map((e) => (
                                        <tr key={e.id}>
                                            <td>{no++}</td>
                                            <td style={{width: "33%"}}>{e.category_name}</td>
                                            <td style={{width: "33%"}}>{e.name}</td>
                                            <td style={{width: "33%"}}>{e.description}</td>

                                            <td style={{whiteSpace: "nowrap"}} className="text-right">
                                                <Dropdown>
                                                    <Dropdown.Toggle id="dropdown-basic"
                                                                     className='outline-info dropDownClass'>
                                                        <span className="nc-icon nc-bullet-list-67"/>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Button title="Edit"
                                                                onClick={async () => {
                                                                    await Axios.post(mainUrl + "getPhoto", {
                                                                        ref_id: e.id,
                                                                        entity_id: 2,
                                                                    }, headers).then(async (res) => {
                                                                        await setShowModal(true);
                                                                        sessionStorage.setItem("categoryImage", res.data);
                                                                        document.getElementById('name').value = e.name;
                                                                        document.getElementById('description').value = e.description;


                                                                        document.getElementById('name_fa').value = e.name_fa;
                                                                        document.getElementById('description_fa').value = e.description_fa;

                                                                        document.getElementById('name_pa').value = e.name_pa;
                                                                        document.getElementById('description_pa').value = e.description_pa;


                                                                        document.getElementById('category_id').value = e.category_id;
                                                                        document.getElementById('id').value = e.id;
                                                                    }).catch(function (error) {
                                                                        notifyError(error.response.data.message);
                                                                    });
                                                                }}

                                                                className="btn-round dropdownlist dropDownClass"
                                                                variant="light" type="Button">
                                                            <span className="nc-icon nc-paper"/>&nbsp;&nbsp;
                                                            Edit
                                                        </Button>
                                                        <br/>
                                                        <Button title="Delete Record" onClick={() => {
                                                            setRecordId(e.id);
                                                            setShowDeleteModal(true);
                                                        }} className="btn-round dropdownlist dropDownClass"
                                                                variant="light" type="Button">
                                                            <span
                                                                className="nc-icon nc-simple-delete "/>&nbsp;&nbsp;
                                                            Delete Record
                                                        </Button>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}
